import React from 'react';

const LabelField = ({ label }) => {
  const isRequired = label.endsWith('*');
  const cleanLabel = isRequired ? label.slice(0, -1).trim() : label;

  return (
    <label className="fw-semibold">
      {cleanLabel}
      {isRequired && <span style={{ color: 'red' }}> *</span>}
    </label>
  );
};

export default LabelField;
